import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./buttonToggle.html";
// Generic, controlled segmented-pill toggle: the parent owns `value` and receives a `select`
// CustomEvent (detail: { value }) when a non-disabled option is clicked. Presentational only —
// no store access, no i18n (all text — including `ariaLabel` — comes from the parent, which is
// where the localized strings live).
class ButtonToggle extends LightningElement {
  constructor(...args) {
    super(...args);
    this.options = [];
    this.value = '';
    // Accessible name for the `role="group"` container, so a screen reader announces what the
    // segments control instead of a bare "group". Forwarded, not hardcoded: one deployment serves
    // four localized experiences, so the string has to come from the consumer's i18n labels.
    // Defaults to null so an omitted label renders no empty `aria-label` attribute.
    this.ariaLabel = null;
    this.analyticsNamePrefix = 'button_toggle_';
    // Consumers can suppress the color transition for programmatic value changes while preserving
    // it for direct user selection. This avoids implying user intent during controlled-state sync.
    this.disableTransition = false;
  }
  get toggleClass() {
    return this.disableTransition ? 'toggle toggle--instant' : 'toggle';
  }
  get rows() {
    return (this.options ?? []).map(option => ({
      ...option,
      pressed: option.value === this.value,
      analyticsContext: {
        button: {
          callToAction: {
            label: option.label,
            name: `${this.analyticsNamePrefix}${option.value}`
          }
        }
      }
    }));
  }
  handleClick(event) {
    const value = event.currentTarget.dataset.value;
    if (!value) {
      return;
    }
    this.dispatchEvent(new CustomEvent('select', {
      detail: {
        value
      }
    }));
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(ButtonToggle, {
  publicProps: {
    options: {
      config: 0
    },
    value: {
      config: 0
    },
    ariaLabel: {
      config: 0
    },
    analyticsNamePrefix: {
      config: 0
    },
    disableTransition: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(ButtonToggle, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;